import "./commonModal.css";
import { useEffect } from "react";

const CommonModal = ({
  show,
  onClose,
  onConfirm,
  title,
  body,
  confirmText = "Confirm",
  showFooter,
  isDarkMode = false,
}) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [show]);

  if (!show) return null;

  return (
    <>
      <div
        onClick={onClose}
        className="modal-backdrop fade show"
        style={{ backdropFilter: "blur(6px)" }}
      />

      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        onClick={onClose}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-sm modal-md-lg"
        >
          <div
            className={`modal-content bg-color-model ${isDarkMode ? "bg-midnight-blue" : ""}`}
            style={{ borderRadius: "14px" }}
            ref={(el) => {
              if (el)
                el.style.setProperty("background", "#1A1A1A", "important");
            }}
          >
            {title && (
              <div
                className="modal-header border-0 pb-0 justify-content-center"
                style={{ color: "#A6A6A6" }}
              >
                {title}
              </div>
            )}

            <div
              className="modal-body text-center"
              style={{ color: "#A6A6A6" }}
            >
              {body}
            </div>

            {showFooter && (
              <div className="modal-footer border-0 pt-0 justify-content-center">
                <button
                  className={`w-50 ${
                    isDarkMode
                      ? "filled-medium-deep-yellow-btn-dark"
                      : "filled-medium-deep-purple-btn-light"
                  }`}
                  onClick={onConfirm}
                >
                  {confirmText}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CommonModal;
